//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as Actions from "./actions";
import { logToSentry } from "utils/networkErrorUtils";
import { has } from "lodash";

export const handleCreateExtraResource = (data) => async (dispatch) => {
  try {
    const response = await apis.post("booksRDS", `/extraResource/create`, {
      body: data,
    });
    if (has(response, "success")) {
      await dispatch(Actions.listExtraResourceBook(response?.data?.results));
    } 
    return response;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'Error in operation',
                error,
                module: 'EXTRA_RESOURCE',
                operation: 'CREATE_EXTRA_RESOURCE'
            });
    }
  }
};

export const handleGetExtraResource = (data) => async (dispatch) => {
  try {
    const { bookId } = data;
    const response = await apis.get(
      "booksRDS",
      `/extraResource/get/${bookId}`
    );
    if (has(response, "success")) {
      await dispatch(Actions.listExtraResourceBook(response?.data));
    }

    return response;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'Error in operation',
                error,
                module: 'EXTRA_RESOURCE',
                operation: 'GET_EXTRA_RESOURCE'
            });
    }
  }
};

export const handleDeleteExtraResource = (id) => async (dispatch) => {
  try {
    const response = await apis.del(
      "booksRDS",
      `/extraResource/delete/${id}`
    );
    if (has(response, "success")) {
      await dispatch(Actions.deleteExtraResourceBook(id));
    }

    return response;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'Error in operation',
                error,
                module: 'EXTRA_RESOURCE',
                operation: 'DELETE_EXTRA_RESOURCE'
            });
    }
  }
};